import { CallerIdState, RemoveCallerIdsAction } from '../types';

export const removeCallerId = (state: CallerIdState, value: RemoveCallerIdsAction) => ({
  ...state,
  callerIds: state.callerIds.filter((item) => item.lineNumber !== value.payload.lineNumber),
});
